export default __webpack_public_path__ + "static/media/New_Gettysburg_LE.fb2e3320.jpg";